/**
 * @description 全大写
 * @param {string} string
 * @returns {string}
 */
export const caseAllBig = (string: string): string => {
  return String(string).toUpperCase()
}

